// extracted by mini-css-extract-plugin
export var layoutContainer = "_dq-0";
export var layoutContainerNoRounding = "_dq-6";
export var layoutContainerOpen = "_dq-5";
export var layoutContainerResizing = "_dq-1";
export var mainContent = "_dq-2";
export var resizeDivider = "_dq-3";
export var slidePanel = "_dq-4";